import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { SalesOrderDataForm, SalesOrderFilters } from '../../models/SalesOrder';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';

const useSalesOrderService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetSalesOrders, setFetchingGetSalesOrders] = useState(false);
    const [fetchingStoreSalesOrder, setFetchingStoreSalesOrder] = useState(false);
    const [fetchingEditSalesOrder, setFetchingEditSalesOrder] = useState(false);
    const [fetchingUpdateSalesOrder, setFetchingUpdateSalesOrder] = useState(false);
    const [fetchingDeleteSalesOrder, setFetchingDeleteSalesOrder] = useState(false);
    const [fetchingActiveSalesOrder, setFetchingActiveSalesOrder] = useState(false);
    const [fetchingGetClientsBySociety, setFetchingGetClientsBySociety] = useState(false);

    const getSalesOrders = (filter: SalesOrderFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filter)
            .filter(([, value]) => value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = EndPoints.SALES_ORDERS.GET_SALES_ORDERS + '?' + queryString;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetSalesOrders
        });
    };

    const storeSalesOrder = (salesOrder: SalesOrderDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.SALES_ORDERS.STORE_SALES_ORDER,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            body: salesOrder,
            setFetching: setFetchingStoreSalesOrder
        });
    };

    const editSalesOrder = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SALES_ORDERS.EDIT_SALES_ORDER.replace(':id', id.toString()),
            setFetching: setFetchingEditSalesOrder
        });
    };

    const updateSalesOrder = (id: number, salesOrder: SalesOrderDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.SALES_ORDERS.UPDATE_SALES_ORDER.replace(':id', id.toString()),
            body: salesOrder,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            setFetching: setFetchingUpdateSalesOrder
        });
    };

    const deleteSalesOrder = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.SALES_ORDERS.DELETE_SALES_ORDER.replace(':id', id.toString()),
            setFetching: setFetchingDeleteSalesOrder
        });
    };

    const activeSalesOrder = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.SALES_ORDERS.ACTIVE_SALES_ORDER.replace(':id', id.toString()),
            body: { active: active },
            setFetching: setFetchingActiveSalesOrder
        });
    };

    const getClientsBySociety = (societyId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.SALES_ORDERS.GET_CLIENTS_BY_SOCIETY.replace(':society_id', societyId.toString()),
            setFetching: setFetchingGetClientsBySociety
        });
    };

    return {
        fetchingGetSalesOrders,
        fetchingStoreSalesOrder,
        fetchingEditSalesOrder,
        fetchingUpdateSalesOrder,
        fetchingDeleteSalesOrder,
        fetchingActiveSalesOrder,
        fetchingGetClientsBySociety,
        getSalesOrders,
        storeSalesOrder,
        editSalesOrder,
        updateSalesOrder,
        deleteSalesOrder,
        activeSalesOrder,
        getClientsBySociety
    };
};

export default useSalesOrderService;

